import { NotificationsState } from './state';

export const notificationsInitialState: NotificationsState = {
  items: [],
  notificationLoaded: false,
};
